import { CommonModule } from '@angular/common';
import { Component, NgModule } from '@angular/core';
import { FindInformationSavedPagesModule } from '@app/components/find-information/find-information-saved-pages/find-information-saved-pages.component';
import { FindInformationTrendingPagesModule } from '@app/components/find-information/find-information-trending-pages/find-information-trending-pages.component';
import { RequiredReadingModule } from '@app/components/required-reading/required-reading.component';
import { FeatureToggleModule } from '@app/directives/feature-toggle.directive';
import { HideParentIfEmptyModule } from '@app/directives/hide-parent-if-empty.directive';
import { MarkComponentVisitedModule } from '@app/directives/mark-component-visited.directive';
import { LinkModule } from '@app/directives/link.directive';
import { CustomFindInformationMegaMenuModule } from '../../components/custom-find-information-mega-menu/custom-find-information-mega-menu.component';
import { InfoboxZoneModule } from '@app/components/infobox-zone/infobox-zone.component';

@Component({
  selector: 'cafcass-custom-find-information',
  templateUrl: './custom-find-information.component.html',
  styleUrls: ['./custom-find-information.component.scss']
})
export class CustomFindInformationComponent { }
@NgModule({
  declarations: [CustomFindInformationComponent],
  exports: [CustomFindInformationComponent],
  imports: [
    CommonModule,
    LinkModule,
    FeatureToggleModule,
    MarkComponentVisitedModule,
    HideParentIfEmptyModule,
    RequiredReadingModule,
    CustomFindInformationMegaMenuModule,
    FindInformationTrendingPagesModule,
    FindInformationSavedPagesModule,
    InfoboxZoneModule
  ]
})
export class CustomFindInformationModule { }
